module.exports = __webpack_public_path__ + "static/media/company.d03c98c2.svg";